/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const FastForwardIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Fast Forward',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M14.149 30.919V5.081a1 1 0 0 1 1.625-.781l16.149 12.919a1 1 0 0 1 0 1.562L15.774 31.7a1 1 0 0 1-1.625-.781ZM12.149 9.519 5.625 4.3A1 1 0 0 0 4 5.081v25.838a1 1 0 0 0 1.625.781l6.524-5.22Z"
    />
  </svg>`;
};
